export enum PaymentTypeEnum {
  CardPayment = 'cardPayment',
  OnlinePayment = 'onlinePayment',
  Blik = 'blik',
  MoneyTransfer = 'moneyTransfer'
}
